import * as yup from "yup";
import { InferType } from "yup";

export const appointmentSchema = yup.object().shape({
  id: yup.string().optional(),
  patientId: yup.string().required("Patient is required"),
  providerId: yup.string().optional(),
  startDate: yup.date().required("Start date is required"),
  startTime: yup.date().required("Start time is required"),
  endTime: yup
    .date()
    .required("End time is required")
    .test("after-start", "End time must be after start time", function (value) {
      const { startTime, startDate } = this.parent;
      if (!value || !startTime || !startDate) return true;

      const startDateTime = new Date(startDate);
      startDateTime.setHours(
        startTime.getHours(),
        startTime.getMinutes(),
        0,
        0
      );

      const endDateTime = new Date(startDate);
      endDateTime.setHours(value.getHours(), value.getMinutes(), 0, 0);

      return endDateTime > startDateTime;
    }),
  colorCode: yup.number().optional(),
  notes: yup
    .string()
    .max(2000, "Notes must be 2000 characters or less")
    .optional(),
});

export type AppointmentFormData = InferType<typeof appointmentSchema>;
